// Date.now() facilitates Jest testing
const getTimestamp = () => new Date(Date.now()).toISOString();

export default getTimestamp;
